import { SuppliesPromotionKind } from "@redotech/cockroachdb-codegen/tables/product/supplies-promotion-kind";
import { SuppliesPromotionStatus } from "@redotech/cockroachdb-codegen/tables/product/supplies-promotion-status";
import { suppliesPromotionIdFormat } from "@redotech/redo-marketplace-id";
import { productIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";

export const SuppliesPromotionStatusSchema = z.nativeEnum(
  SuppliesPromotionStatus,
);
export const SuppliesPromotionKindSchema = z.nativeEnum(SuppliesPromotionKind);

const SuppliesPromotionSchema_ = z.object({
  id: suppliesPromotionIdFormat.schema,
  kind: SuppliesPromotionKindSchema,
  thresholdAmount: z.number(),
  status: SuppliesPromotionStatusSchema,
  title: z.string(),
  storefrontMessage: z.string().nullable(),
  firstTimeCustomersOnly: z.boolean(),
  eligibleProducts: z.array(
    z.object({ id: productIdFormat.schema, title: z.string() }),
  ),
  createdAt: z.date(),
  updatedAt: z.date(),
});
export const SuppliesPromotionSchema: z.ZodType<SuppliesPromotion> =
  SuppliesPromotionSchema_;
export interface SuppliesPromotion extends z.infer<
  typeof SuppliesPromotionSchema_
> {}

export type EligibleProduct = SuppliesPromotion["eligibleProducts"][number];
